var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-fullheight"},[_c('div',{staticClass:"hero-head"},[_c('the-header')],1),_c('div',{staticClass:"hero-body"},[_c('the-sidebar'),_c('main',[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }